var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C14.76 1 17 3.24026 17 5.99764L17.9979 6C19.1036 6 20.0559 6.89451 20.1246 7.99406L20.8754 20.0059C20.9442 21.1072 20.1074 22 19.0049 22H4.99507C3.89321 22 3.05589 21.1055 3.12461 20.0059L3.87535 7.99406C3.94418 6.89277 4.8945 6 6.00211 6H6.99998C6.99998 3.23876 9.24181 1 12 1ZM15 6C15 4.34477 13.6554 3 12 3C10.3458 3 8.99998 4.34394 8.99998 5.99764L15 6ZM6.99998 8H6.00211C5.95068 8 5.87441 8.07155 5.87146 8.11882L5.13634 20L18.8709 19.9974L18.1285 8.11882C18.1257 8.07335 18.0475 8 17.9979 8H17V10C17 10.5523 16.5523 11 16 11C15.4477 11 15 10.5523 15 10V8H8.99998V10C8.99998 10.5523 8.55227 11 7.99998 11C7.4477 11 6.99998 10.5523 6.99998 10V8ZM6.99998 17C6.99998 16.4477 7.44909 16 7.99538 16H16.0046C16.5543 16 17 16.4439 17 17C17 17.5523 16.5509 18 16.0046 18H7.99538C7.44564 18 6.99998 17.5561 6.99998 17Z",
    fill: "#181A19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.078d33eca6159c2ff55157d8c393718a.svg";
export { ForwardRef as ReactComponent };